var Handlebars = require("../../common/js/handlebarHelper");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"d-inline-block fw-bold text-black-400 search__result--text font-28 font-md-40 heading-font-family\"> \""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"searchText") || (depth0 != null ? lookupProperty(depth0,"searchText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"searchText","hash":{},"data":data,"loc":{"start":{"line":1,"column":114},"end":{"line":1,"column":128}}}) : helper)))
    + "\"</span>";
},"useData":true});